import styled from "styled-components";

import OptionsMenu from "app/pages/sales-intelligence/common-components/options-menu/OptionsMenu/OptionsMenu";

export const StyledListOptionsMenu = styled(OptionsMenu)`
    display: flex;
    align-items: center;
    margin-left: 16px;
    flex: none;
`;
